import 'media-chrome';
import { MediaThemeElement } from 'media-chrome/dist/media-theme-element.js';
const templateElement = document.createElement('template');
templateElement.innerHTML = /* html */ `
  <style>
    :host {
      --media-control-padding: none;
      --media-control-background: none;
      --media-control-hover-background: none;

      --media-time-range-buffered-color: rgba(var(--color-on-background-rgb, 0, 0, 0), 0.1);

      --media-range-track-background: rgba(var(--color-on-background-rgb, 0, 0, 0), 0.1);
      --media-range-track-height: 2px;
      --media-range-thumb-height: 14px;
      --media-range-thumb-width: 14px;
      --media-range-thumb-background: var(--color-on-background, #000000);
      --media-range-bar-color: var(--color-on-background, #000000);

      --media-icon-color: var(--color-on-background, #000000);

      --media-text-color: var(--color-on-background, #000000);

      --media-font-size: 14px;
      --media-font-family: var(--font-family-base, sans-serif);

      height: 20px;
    }

    *[role=button]:hover {
      --media-icon-color: var(--color-primary, #000000);
    }

    media-controller {
      background: none;
    }

    media-play-button {
      position: absolute;
      top: 50%;
      left: 0px;

      transform: translateY(-50%);
    }

    media-time-range {
      position: absolute;
      top: 50%;
      right: 70px;
      left: 90px;

      transform: translateY(-50%);

      width: auto;
    }

    media-time-display {
      position: absolute;
      top: 50%;
      left: 36px;

      transform: translateY(-50%);
    }

    media-duration-display {
      position: absolute;

      top: 50%;
      right: 0px;
      transform: translateY(-50%);
    }

  </style>

  <media-controller audio defaultduration="{{defaultduration}}">
    <slot name="media" slot="media"></slot>

    <media-play-button>
      <div slot="play" style="display:flex;">
        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.988 7.553a.5.5 0 0 1 0 .894L1.224 14.83a.5.5 0 0 1-.724-.447V1.618a.5.5 0 0 1 .724-.447l12.764 6.382Z" fill="var(--media-icon-color)" stroke="var(--media-icon-color)"/></svg>
      </div>
      <span slot="pause" style="display:flex;">
        <svg height="16" width="!6" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0h8v32H4V0ZM20 0h8v32h-8V0Z" fill="var(--media-icon-color)"/></svg>
      </span>
    </media-play-button>

    <media-time-display notoggle></media-time-display>

    <media-time-range>
      <span slot="preview"></span>
    </media-time-range>

    <media-duration-display></media-duration-display>
  </media-controller>
`;
class MediaThemeFourthwallAudioMessage extends MediaThemeElement {
    static template = templateElement;
}
if (!globalThis.customElements.get('media-theme-fourthwall-audio-message')) {
    globalThis.customElements.define('media-theme-fourthwall-audio-message', MediaThemeFourthwallAudioMessage);
}
export default MediaThemeFourthwallAudioMessage;
